import { OverridedMixpanel } from 'mixpanel-browser';

/*
 * Mock all functions
 */
export const mockMixpanel = new Proxy(
  {},
  {
    get() {
      return noop;
    }
  }
) as OverridedMixpanel;

function noop() {}
